import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FaRegCircleQuestion } from 'react-icons/fa6';
import {
  Button,
  Collapse,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Navbar,
  NavbarBrand,
  NavbarToggler
} from 'reactstrap';
import config from '../../config.json';
import { UserRoleType } from '../../types/constants';
import useAuth from '../../hook/useAuth';
import useToggle from '../../hook/useToggle';
import { RoutePath, parseRoutePath } from '../../router';
import AuthWrapper from '../common/auth-wrapper';
import { useFrench } from '../french/french-context';
import "./style.scss";
import UserMenu from './user-menu';

export default function NavBar() {
  const [activeTab, setActiveTab] = useState(RoutePath.Hierarchy);

  const [{ isFrenchChecked }, dispatch] = useFrench();

  const { isAdmin, isFrenchTranslator } = useAuth();

  const { isOpen, toggle } = useToggle();

  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    Object.entries(RoutePath).forEach(([k, v]) => {
      if (pathname.startsWith('/' + v)) {
        setActiveTab(RoutePath[k as keyof typeof RoutePath]);
      }
    });

  }, [location.pathname]);

  const option = {
    color: "light",
    light: true,
    dark: false,
    expand: "md"
  };

  const handleShowFrench = () =>
    dispatch({ type: 'TOGGLE_FRENCH' });

  return (
    <Navbar {...option} className="oms-navbar p-0">
      <NavbarBrand>
        <img src='images/favicon.svg' alt='OMS logo' style={{width: '40px', paddingRight: '5px'}} />
        OMS <span className="version" aria-hidden={true}>{config.omsVersion}</span>
      </NavbarBrand>

      <NavbarToggler onClick={toggle} />

      <Collapse isOpen={isOpen} navbar>
        <Nav id="oms_nav" className="me-auto" navbar>
          <AuthWrapper role={[UserRoleType.ADMINISTRATOR, UserRoleType.COORDINATOR, UserRoleType.FRENCHTRANSLATOR]}>
            <NavItem>
              <NavLink href={parseRoutePath(RoutePath.Hierarchy)}
                onClick={() => setActiveTab(RoutePath.Hierarchy)}
                active={activeTab === RoutePath.Hierarchy}>
                Hierarchy
              </NavLink>
            </NavItem>
          </AuthWrapper>
          <AuthWrapper role={[UserRoleType.ADMINISTRATOR, UserRoleType.FRENCHTRANSLATOR]}>
            <NavItem>
              <NavLink href={parseRoutePath(RoutePath.FrenchQueue)}
                onClick={() => setActiveTab(RoutePath.FrenchQueue)}
                active={activeTab === RoutePath.FrenchQueue}>
                French Queue
              </NavLink>
            </NavItem>
          </AuthWrapper>
          <AuthWrapper role={[UserRoleType.ADMINISTRATOR, UserRoleType.COORDINATOR]}>
            <NavItem>
              <NavLink href={parseRoutePath(RoutePath.OmsUsers)}
                onClick={() => setActiveTab(RoutePath.OmsUsers)}
                active={activeTab === RoutePath.OmsUsers}>
                OMS Users
              </NavLink>
            </NavItem>
          </AuthWrapper>
          <AuthWrapper role={UserRoleType.ADMINISTRATOR}>
            <NavItem>
              <NavLink href={parseRoutePath(RoutePath.Administration)}
                onClick={() => setActiveTab(RoutePath.Administration)}
                active={activeTab === RoutePath.Administration}>
                Administration
              </NavLink>
            </NavItem>
          </AuthWrapper>
          <AuthWrapper role={UserRoleType.RESTADMIN}>
            <NavItem>
              <NavLink href={parseRoutePath(RoutePath.RestAdminConsole)}
                onClick={() => setActiveTab(RoutePath.RestAdminConsole)}
                active={activeTab === RoutePath.RestAdminConsole}>
                WS Admin Console
              </NavLink>
            </NavItem>
          </AuthWrapper>
        </Nav>

        {(isAdmin || isFrenchTranslator) &&
          <FormGroup check className="me-3">
            <Input type="checkbox" id="showFrench" name="showFrench" checked={isFrenchChecked}
              onChange={handleShowFrench} />
            {' '}
            <Label for="showFrench" check>Show French</Label>
          </FormGroup>
        }
        <a href="/help.html" target='_blank' title='Show help' aria-label='Show help' className='btn btn-light' style={{ marginRight: '8px' }}>
          <FaRegCircleQuestion size="2rem" color='#000' />
        </a>
        <UserMenu />
      </Collapse>
    </Navbar>
  )
}
 